
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index0_SRxDa2tUee7kq7g_h2xJ5nF_VDNroQ9XCGObnUzGsMeta } from "/opt/build/repo/pages/users/accept-invite/[uuid]/index.vue?macro=true";
import { default as newEWqOx61UmWDDFTcdq_RCfirCR3e__Xr0xyfhBdWL4e0Meta } from "/opt/build/repo/pages/companies/new.vue?macro=true";
import { default as addENN0d8SPpYO72EpQqlrs1YHon8MAlSNeK1fReqRZ9IkMeta } from "/opt/build/repo/pages/inventory/add.vue?macro=true";
import { default as transferYp9nwa9d9yFbzVYboRmEeWtNnXZI_69HktXbwBig0uEMeta } from "/opt/build/repo/pages/inventory/transfer.vue?macro=true";
import { default as new3fHErSkQFuvsJL2i6st9B_pO4olMTLElY5WpnoCOPfUMeta } from "/opt/build/repo/pages/orders/new.vue?macro=true";
import { default as newu4ETut3sFxzZ3nfEkgM1uHdx_GpA9hK_ev2Em0i1bmwMeta } from "/opt/build/repo/pages/projects/new.vue?macro=true";
import { default as bom_45itemsS1lVKrDlW9KLWlEJ9z8mJ5lLAeoQ4fs6pGdvnTUn0IIMeta } from "/opt/build/repo/pages/purchase-orders/new/bom-items.vue?macro=true";
import { default as newbqiaIFq7GSFMzR97NenAQYTqOthYFIopbj3167b3WwkMeta } from "/opt/build/repo/pages/purchase-orders/new.vue?macro=true";
import { default as newtXqoOFv8cc4bOjnwZmNfQeAtKQFuDL2T_vLMP9C7gy4Meta } from "/opt/build/repo/pages/users/new.vue?macro=true";
import { default as editqQQo7r8t4e9kpeBUanpMGyCe2jHZ7Mtc3yrOa_VvIlQMeta } from "/opt/build/repo/pages/users/[id]/edit.vue?macro=true";
import { default as _91id_936_YnI_lB8wt21BppDogOJY2yX82OidOQXUnMKkCMRsYMeta } from "/opt/build/repo/pages/companies/[id].vue?macro=true";
import { default as editHsr3H_K40rv9FjEYKPbLDeWbWpcFKlut3ClwHqcEHTAMeta } from "/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit.vue?macro=true";
import { default as _91invoice_93nIIbMu6qtgG2gSmhfAV0BCaZ9iUXtMiCWmJ3b0FPKIAMeta } from "/opt/build/repo/pages/orders/[id]/invoices/[invoice].vue?macro=true";
import { default as _91quote_93J_V6DlnAN_UN_cyLsGnyGllxx2rAIlb7UobT_XOUVBwMeta } from "/opt/build/repo/pages/orders/[id]/quotes/[quote].vue?macro=true";
import { default as bom_45itemsuL3ywJfVKIOb8DwKcKXpPopUX6aBGoV_CCRDQlq1_pAMeta } from "/opt/build/repo/pages/orders/[id]/change-order/bom-items.vue?macro=true";
import { default as change_45orderFA36AwWBgz3hXdD9Kx1DLijqOadto0uKSNDX1sm2AcsMeta } from "/opt/build/repo/pages/orders/[id]/change-order.vue?macro=true";
import { default as bom_45itemsGZnQhvLURkD5m345Q_vXm7kD3AraSzdpO_YHLjfs76oMeta } from "/opt/build/repo/pages/orders/[id]/complete-draft/bom-items.vue?macro=true";
import { default as complete_45draftl_eZzShfmSj5SmDtAudan18ENFZ6hLHN6SP0qZiYh04Meta } from "/opt/build/repo/pages/orders/[id]/complete-draft.vue?macro=true";
import { default as bom_45itemsi65Jw5xiLQIrd4JCFGQ9xksEVx9MNXZQI8BptFz9G_0Meta } from "/opt/build/repo/pages/orders/[id]/final-adjustments/bom-items.vue?macro=true";
import { default as final_45adjustmentsqiog97bkUI0ul10EBV5MpIHG5ym4ge_4ZSSxxjq1ThYMeta } from "/opt/build/repo/pages/orders/[id]/final-adjustments.vue?macro=true";
import { default as receiveG5wo8pZT_2EwMO6ODLmhNTxHVWl6ys68Fye_NlBV7UEMeta } from "/opt/build/repo/pages/orders/[id]/receive.vue?macro=true";
import { default as _91id_93eGjb_5_2ekpT_MwsgfC3ZV6OpVo5Sv25T4O6Lpn_MQkMeta } from "/opt/build/repo/pages/orders/[id].vue?macro=true";
import { default as indexSaXeRkScaX8EDlpLrA4k9Ov_c9CgcuV_fZngt5szpOAMeta } from "/opt/build/repo/pages/projects/[id]/boms/[bomId]/index.vue?macro=true";
import { default as _91bomId_93f5M_ZSWx_D31JQTuOAtOhAD2gb0ZDdzItcBJO0PAhgwMeta } from "/opt/build/repo/pages/projects/[id]/boms/[bomId].vue?macro=true";
import { default as indexloVz2PFohGGajaUvLoRaBAtFYH6PmWUIi18ay1zH3KAMeta } from "/opt/build/repo/pages/projects/[id]/index.vue?macro=true";
import { default as _91id_934krCkdKbF0WnmiXLLt8RrNduF_rX9e2BYDlQtQhwAtUMeta } from "/opt/build/repo/pages/projects/[id].vue?macro=true";
import { default as _91uuid_93YBPZxHSxOjcY_J7jhxT4u_c8AeXlAuCcV1LIEbEz1NIMeta } from "/opt/build/repo/pages/verify-email/[uuid].vue?macro=true";
import { default as accountingCbEJK1_JC2evcozFjFObAZXnZWy40EztjsnXJN7EFuAMeta } from "/opt/build/repo/pages/accounting.vue?macro=true";
import { default as accounting_45exportmbjyU3zasDAoWgTkCxBRyZXgA2RdKXbPXxBOcelAGncMeta } from "/opt/build/repo/pages/accounting-export.vue?macro=true";
import { default as indexNQNGevhHl5EOSCSbNXLSk0gMwfcrF86lATpVyqywmOEMeta } from "/opt/build/repo/pages/admin/index.vue?macro=true";
import { default as adminUkAjC8h_dMY6Una1Q8fbXtFIf9RlQJ5gXVC9oB6abwAMeta } from "/opt/build/repo/pages/admin.vue?macro=true";
import { default as indexb71or2Kox6hT_LXAETSlwMcpKrjuc4_WDO0Syov3Uy8Meta } from "/opt/build/repo/pages/boms/index.vue?macro=true";
import { default as components6c5rAQkgP5bw5KX3F63hRz5cCgnkn9eLth6H72GskxAMeta } from "/opt/build/repo/pages/components.vue?macro=true";
import { default as dashboardXZDZjzi_tqfZzr_Zbs4x0NDqXk_KqTTs80Jgwyh2z00Meta } from "/opt/build/repo/pages/dashboard.vue?macro=true";
import { default as indexk1asxzRLb8lag7WgpmUhr5TGCNjImeHvLaP7BVrqIREMeta } from "/opt/build/repo/pages/error-test/index.vue?macro=true";
import { default as editMlBsyNRb82blHwj00_7MvbDykQH1htvomFOoMbb693QMeta } from "/opt/build/repo/pages/expenses/[id]/edit.vue?macro=true";
import { default as _91id_93t6HKUPZXO5PvYcaI5s5IzhWSjcONiGJeF1f3Hm2dFFQMeta } from "/opt/build/repo/pages/expenses/[id].vue?macro=true";
import { default as expensesaxgS2mz5uE4xk2_mhGI2rfDmGL0rIwaCyF4a71bndoAMeta } from "/opt/build/repo/pages/expenses.vue?macro=true";
import { default as forgot_45passwordVnp08g8UP5IibR6KIZMlsnAFBHWyQodiyjtdQRScWBIMeta } from "/opt/build/repo/pages/forgot-password.vue?macro=true";
import { default as indexW6WZCIAz_phem_WCVaxz_3diYEk1wjnRMy5GyS6lwUgMeta } from "/opt/build/repo/pages/inventory/index.vue?macro=true";
import { default as indexnf6UKP8TY2PP2HIr60mkm5ibNeIK_6bSwNIg6mgcq0AMeta } from "/opt/build/repo/pages/invoices/index.vue?macro=true";
import { default as invoicesDOZZG5N4QFrQYQWAi3snrXiIPBRSCOIF_suIwopVh2EMeta } from "/opt/build/repo/pages/invoices.vue?macro=true";
import { default as logingUcKU0V7fZP3Ss3UByM2PjTTHYd1pgiwb9kFWthzQbUMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as indexqjdthQPIBM9IhD2VRI0aXKEOJddcv72aAbUDCMXk7qUMeta } from "/opt/build/repo/pages/orders/index.vue?macro=true";
import { default as profileMef4H_TYc_66_EJ0KHQA0H9_ahI_1_KuhHgYlomIVdYMeta } from "/opt/build/repo/pages/profile.vue?macro=true";
import { default as indexgc71qn6UgAQ5o_7jsauI59C7PZZaVPgfD5q0UNTMtYYMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as quickbooks_45disconnectuVWpUOT7fldfVIv8_8Y3W1fcvi_Zrj_rK1uYs5XNoYEMeta } from "/opt/build/repo/pages/quickbooks-disconnect.vue?macro=true";
import { default as index_Dscy93lXj6vUUjoatFJmc5AeVJyM77QFoHw2PTnY4QMeta } from "/opt/build/repo/pages/requisitions/[id]/index.vue?macro=true";
import { default as requisitions8Sz_nrXxm2Tg5Oo9SD_tct6PYrXu8BchN9hIZvkzz5oMeta } from "/opt/build/repo/pages/requisitions.vue?macro=true";
import { default as sign_45up8yzWxtkMj99FD6mwxWcUj_iXyg5WAvGnnnnYEnqRlRMMeta } from "/opt/build/repo/pages/sign-up.vue?macro=true";
import { default as sign_45up_45mobileOw95MmiD9hJdPAqaafAD6MFXHD7zaGwQm3PjhSSvMIAMeta } from "/opt/build/repo/pages/sign-up-mobile.vue?macro=true";
import { default as signingcz51Se5zPLdV0sv3iPkR9ycPuliB7BZW_hk5njJyrVEMeta } from "/opt/build/repo/pages/signing.vue?macro=true";
import { default as newekVGmRxWzRZSDWRbIfpHr16T8hyP0MDTHNRdQE4YPQIMeta } from "/opt/build/repo/pages/suppliers/new.vue?macro=true";
import { default as editc57_uvoCEnmtNBW6k1leWbaGGIHTPBBLVbKQPntFqRwMeta } from "/opt/build/repo/pages/suppliers/[id]/edit.vue?macro=true";
import { default as suppliersORjQ_GFEA_xLASvPA8clslMAM5Z9Hp9M0Ab5yA_Kk4AMeta } from "/opt/build/repo/pages/suppliers.vue?macro=true";
import { default as indexZeHzX2B12kodz3iEviVHBV4jjUVq0oWqo_g5ttjaVzUMeta } from "/opt/build/repo/pages/users/index.vue?macro=true";
import { default as indexAFyRF2Bn_1ZTsou4nMHZtf7Tr5u4fbbDR_Vv2gtSIp4Meta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as import_JbSqzSS_kmtosqvsJ4KkFPiejyC1kGj304JoM08MJoMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/import.vue?macro=true";
import { default as adddGoa_TcjXjf7LOyMrKux03k189NfAe3cxjEIwxqrLOYMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/add.vue?macro=true";
import { default as editlplrrgAJfjuGT7m20O5Vg1NBiG9hLKXuTF2hhDsHFC4Meta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit.vue?macro=true";
import { default as _91companyVendorId_93L56KD4yLe4xRoSMkhWRyORLmtMJ9TLGk7NR_7IqH6EoMeta } from "/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId].vue?macro=true";
import { default as suppliersaM_uZuX1Ih6GBr2vmbsl_v8QrroFVj7_Z6rFuqzrAfQMeta } from "/opt/build/repo/pages/companies/[id]/suppliers.vue?macro=true";
import { default as newNTTcQDB_rDrDnG56lE8RA0FNC8e6veZjY4wHVANRFmcMeta } from "/opt/build/repo/pages/invoices/new.vue?macro=true";
import { default as new_sypVvLZdQyc1WMLWPlf6IxERR_Blc0_wNAEDt5t4ZcMeta } from "/opt/build/repo/pages/requisitions/new.vue?macro=true";
import { default as editYdJdxHayb0MvPeg6P01iiPoTOfFAnTHLU8jKnpwxmL0Meta } from "/opt/build/repo/pages/requisitions/[id]/edit.vue?macro=true";
export default [
  {
    name: "users-accept-invite-uuid",
    path: "/users/accept-invite/:uuid()",
    meta: index0_SRxDa2tUee7kq7g_h2xJ5nF_VDNroQ9XCGObnUzGsMeta || {},
    component: () => import("/opt/build/repo/pages/users/accept-invite/[uuid]/index.vue")
  },
  {
    name: "companies-new",
    path: "/companies/new",
    meta: { ...(newEWqOx61UmWDDFTcdq_RCfirCR3e__Xr0xyfhBdWL4e0Meta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/companies/new.vue")
  },
  {
    name: "inventory-add",
    path: "/inventory/add",
    meta: addENN0d8SPpYO72EpQqlrs1YHon8MAlSNeK1fReqRZ9IkMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/add.vue")
  },
  {
    name: "inventory-transfer",
    path: "/inventory/transfer",
    meta: transferYp9nwa9d9yFbzVYboRmEeWtNnXZI_69HktXbwBig0uEMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/transfer.vue")
  },
  {
    name: new3fHErSkQFuvsJL2i6st9B_pO4olMTLElY5WpnoCOPfUMeta?.name,
    path: "/orders/new",
    meta: { ...(new3fHErSkQFuvsJL2i6st9B_pO4olMTLElY5WpnoCOPfUMeta || {}), ...{"middleware":"can-get-quotes"} },
    component: () => import("/opt/build/repo/pages/orders/new.vue"),
    children: [
  {
    name: "orders-new-delivery",
    path: "delivery",
    component: () => import("/opt/build/repo/pages/orders/new/delivery.vue")
  },
  {
    name: "orders-new-invite-suppliers",
    path: "invite-suppliers",
    component: () => import("/opt/build/repo/pages/orders/new/invite-suppliers.vue")
  },
  {
    name: "orders-new-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/orders/new/review.vue")
  },
  {
    name: "orders-new",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/new/index.vue")
  }
]
  },
  {
    name: "projects-new",
    path: "/projects/new",
    meta: newu4ETut3sFxzZ3nfEkgM1uHdx_GpA9hK_ev2Em0i1bmwMeta || {},
    component: () => import("/opt/build/repo/pages/projects/new.vue")
  },
  {
    name: newbqiaIFq7GSFMzR97NenAQYTqOthYFIopbj3167b3WwkMeta?.name,
    path: "/purchase-orders/new",
    meta: { ...(newbqiaIFq7GSFMzR97NenAQYTqOthYFIopbj3167b3WwkMeta || {}), ...{"middleware":"can-create-po"} },
    component: () => import("/opt/build/repo/pages/purchase-orders/new.vue"),
    children: [
  {
    name: "purchase-orders-new-bom-items",
    path: "bom-items",
    meta: bom_45itemsS1lVKrDlW9KLWlEJ9z8mJ5lLAeoQ4fs6pGdvnTUn0IIMeta || {},
    component: () => import("/opt/build/repo/pages/purchase-orders/new/bom-items.vue")
  },
  {
    name: "purchase-orders-new",
    path: "",
    component: () => import("/opt/build/repo/pages/purchase-orders/new/index.vue")
  }
]
  },
  {
    name: "users-new",
    path: "/users/new",
    meta: { ...(newtXqoOFv8cc4bOjnwZmNfQeAtKQFuDL2T_vLMP9C7gy4Meta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/new.vue")
  },
  {
    name: "users-id-edit",
    path: "/users/:id()/edit",
    meta: { ...(editqQQo7r8t4e9kpeBUanpMGyCe2jHZ7Mtc3yrOa_VvIlQMeta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/[id]/edit.vue")
  },
  {
    name: "boms-id",
    path: "/boms/:id()",
    component: () => import("/opt/build/repo/pages/boms/[id].vue")
  },
  {
    name: _91id_936_YnI_lB8wt21BppDogOJY2yX82OidOQXUnMKkCMRsYMeta?.name,
    path: "/companies/:id()",
    meta: { ...(_91id_936_YnI_lB8wt21BppDogOJY2yX82OidOQXUnMKkCMRsYMeta || {}), ...{"middleware":"can-manage-company"} },
    component: () => import("/opt/build/repo/pages/companies/[id].vue"),
    children: [
  {
    name: "companies-id-accounting-setup",
    path: "accounting/setup",
    meta: {"middleware":"staff"},
    component: () => import("/opt/build/repo/pages/companies/[id]/accounting/setup.vue")
  },
  {
    name: "companies-id-accounting",
    path: "accounting",
    component: () => import("/opt/build/repo/pages/companies/[id]/accounting/index.vue")
  },
  {
    name: "companies-id-cost-codes",
    path: "cost-codes",
    component: () => import("/opt/build/repo/pages/companies/[id]/cost-codes.vue")
  },
  {
    name: "companies-id-purchase-order",
    path: "purchase-order",
    component: () => import("/opt/build/repo/pages/companies/[id]/purchase-order.vue")
  },
  {
    name: "companies-id-report-config",
    path: "report-config",
    component: () => import("/opt/build/repo/pages/companies/[id]/report-config.vue")
  },
  {
    name: "companies-id-restricted",
    path: "restricted",
    meta: {"middleware":"staff"},
    component: () => import("/opt/build/repo/pages/companies/[id]/restricted.vue")
  },
  {
    name: "companies-id-roles",
    path: "roles",
    component: () => import("/opt/build/repo/pages/companies/[id]/roles.vue")
  },
  {
    name: "companies-id",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/index.vue")
  }
]
  },
  {
    name: _91id_93eGjb_5_2ekpT_MwsgfC3ZV6OpVo5Sv25T4O6Lpn_MQkMeta?.name,
    path: "/orders/:id()",
    meta: _91id_93eGjb_5_2ekpT_MwsgfC3ZV6OpVo5Sv25T4O6Lpn_MQkMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id].vue"),
    children: [
  {
    name: _91invoice_93nIIbMu6qtgG2gSmhfAV0BCaZ9iUXtMiCWmJ3b0FPKIAMeta?.name,
    path: "invoices/:invoice()",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice].vue"),
    children: [
  {
    name: editHsr3H_K40rv9FjEYKPbLDeWbWpcFKlut3ClwHqcEHTAMeta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit.vue"),
    children: [
  {
    name: "orders-id-invoices-invoice-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/edit/index.vue")
  }
]
  },
  {
    name: "orders-id-invoices-invoice",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/invoices/[invoice]/index.vue")
  }
]
  },
  {
    name: _91quote_93J_V6DlnAN_UN_cyLsGnyGllxx2rAIlb7UobT_XOUVBwMeta?.name,
    path: "quotes/:quote()",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote].vue"),
    children: [
  {
    name: "orders-id-quotes-quote-match-items",
    path: "match-items",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote]/match-items.vue")
  },
  {
    name: "orders-id-quotes-quote",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/quotes/[quote]/index.vue")
  }
]
  },
  {
    name: "orders-id-bom-pricing",
    path: "bom-pricing",
    component: () => import("/opt/build/repo/pages/orders/[id]/bom-pricing.vue")
  },
  {
    name: change_45orderFA36AwWBgz3hXdD9Kx1DLijqOadto0uKSNDX1sm2AcsMeta?.name,
    path: "change-order",
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order.vue"),
    children: [
  {
    name: "orders-id-change-order-bom-items",
    path: "bom-items",
    meta: bom_45itemsuL3ywJfVKIOb8DwKcKXpPopUX6aBGoV_CCRDQlq1_pAMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order/bom-items.vue")
  },
  {
    name: "orders-id-change-order",
    path: "",
    meta: {"middleware":"can-create-change-order"},
    component: () => import("/opt/build/repo/pages/orders/[id]/change-order/index.vue")
  }
]
  },
  {
    name: complete_45draftl_eZzShfmSj5SmDtAudan18ENFZ6hLHN6SP0qZiYh04Meta?.name,
    path: "complete-draft",
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft.vue"),
    children: [
  {
    name: "orders-id-complete-draft-bom-items",
    path: "bom-items",
    meta: bom_45itemsGZnQhvLURkD5m345Q_vXm7kD3AraSzdpO_YHLjfs76oMeta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft/bom-items.vue")
  },
  {
    name: "orders-id-complete-draft",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/complete-draft/index.vue")
  }
]
  },
  {
    name: "orders-id-edit",
    path: "edit",
    component: () => import("/opt/build/repo/pages/orders/[id]/edit.vue")
  },
  {
    name: final_45adjustmentsqiog97bkUI0ul10EBV5MpIHG5ym4ge_4ZSSxxjq1ThYMeta?.name,
    path: "final-adjustments",
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments.vue"),
    children: [
  {
    name: "orders-id-final-adjustments-bom-items",
    path: "bom-items",
    meta: bom_45itemsi65Jw5xiLQIrd4JCFGQ9xksEVx9MNXZQI8BptFz9G_0Meta || {},
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments/bom-items.vue")
  },
  {
    name: "orders-id-final-adjustments",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/final-adjustments/index.vue")
  }
]
  },
  {
    name: "orders-id-in-store",
    path: "in-store",
    component: () => import("/opt/build/repo/pages/orders/[id]/in-store.vue")
  },
  {
    name: "orders-id-invite-suppliers",
    path: "invite-suppliers",
    component: () => import("/opt/build/repo/pages/orders/[id]/invite-suppliers.vue")
  },
  {
    name: receiveG5wo8pZT_2EwMO6ODLmhNTxHVWl6ys68Fye_NlBV7UEMeta?.name,
    path: "receive",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive.vue"),
    children: [
  {
    name: "orders-id-receive-submit",
    path: "submit",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive/submit.vue")
  },
  {
    name: "orders-id-receive",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/receive/index.vue")
  }
]
  },
  {
    name: "orders-id-release",
    path: "release",
    component: () => import("/opt/build/repo/pages/orders/[id]/release.vue")
  },
  {
    name: "orders-id",
    path: "",
    component: () => import("/opt/build/repo/pages/orders/[id]/index.vue")
  }
]
  },
  {
    name: _91id_934krCkdKbF0WnmiXLLt8RrNduF_rX9e2BYDlQtQhwAtUMeta?.name,
    path: "/projects/:id()",
    component: () => import("/opt/build/repo/pages/projects/[id].vue"),
    children: [
  {
    name: _91bomId_93f5M_ZSWx_D31JQTuOAtOhAD2gb0ZDdzItcBJO0PAhgwMeta?.name,
    path: "boms/:bomId()",
    meta: _91bomId_93f5M_ZSWx_D31JQTuOAtOhAD2gb0ZDdzItcBJO0PAhgwMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId].vue"),
    children: [
  {
    name: "projects-id-boms-bomId-scan",
    path: "scan",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/scan.vue")
  },
  {
    name: indexSaXeRkScaX8EDlpLrA4k9Ov_c9CgcuV_fZngt5szpOAMeta?.name,
    path: "",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index.vue"),
    children: [
  {
    name: "projects-id-boms-bomId-index-orders",
    path: "orders",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index/orders.vue")
  },
  {
    name: "projects-id-boms-bomId-index",
    path: "",
    component: () => import("/opt/build/repo/pages/projects/[id]/boms/[bomId]/index/index.vue")
  }
]
  }
]
  },
  {
    name: "projects-id",
    path: "",
    meta: indexloVz2PFohGGajaUvLoRaBAtFYH6PmWUIi18ay1zH3KAMeta || {},
    component: () => import("/opt/build/repo/pages/projects/[id]/index.vue")
  }
]
  },
  {
    name: "verify-email-uuid",
    path: "/verify-email/:uuid()",
    meta: { ...(_91uuid_93YBPZxHSxOjcY_J7jhxT4u_c8AeXlAuCcV1LIEbEz1NIMeta || {}), ...{"middleware":"signup-enabled"} },
    component: () => import("/opt/build/repo/pages/verify-email/[uuid].vue")
  },
  {
    name: accountingCbEJK1_JC2evcozFjFObAZXnZWy40EztjsnXJN7EFuAMeta?.name,
    path: "/accounting",
    meta: accountingCbEJK1_JC2evcozFjFObAZXnZWy40EztjsnXJN7EFuAMeta || {},
    component: () => import("/opt/build/repo/pages/accounting.vue"),
    children: [
  {
    name: "accounting-pending-sync",
    path: "pending-sync",
    component: () => import("/opt/build/repo/pages/accounting/pending-sync.vue")
  },
  {
    name: "accounting",
    path: "",
    component: () => import("/opt/build/repo/pages/accounting/index.vue")
  }
]
  },
  {
    name: accounting_45exportmbjyU3zasDAoWgTkCxBRyZXgA2RdKXbPXxBOcelAGncMeta?.name,
    path: "/accounting-export",
    meta: accounting_45exportmbjyU3zasDAoWgTkCxBRyZXgA2RdKXbPXxBOcelAGncMeta || {},
    component: () => import("/opt/build/repo/pages/accounting-export.vue"),
    children: [
  {
    name: "accounting-export-order",
    path: ":order()",
    component: () => import("/opt/build/repo/pages/accounting-export/[order].vue")
  },
  {
    name: "accounting-export",
    path: "",
    component: () => import("/opt/build/repo/pages/accounting-export/index.vue")
  }
]
  },
  {
    name: adminUkAjC8h_dMY6Una1Q8fbXtFIf9RlQJ5gXVC9oB6abwAMeta?.name,
    path: "/admin",
    meta: { ...(adminUkAjC8h_dMY6Una1Q8fbXtFIf9RlQJ5gXVC9oB6abwAMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/admin.vue"),
    children: [
  {
    name: "admin-dashboard",
    path: "dashboard",
    component: () => import("/opt/build/repo/pages/admin/dashboard/index.vue")
  },
  {
    name: "admin-emails",
    path: "emails",
    component: () => import("/opt/build/repo/pages/admin/emails/index.vue")
  },
  {
    name: "admin",
    path: "",
    meta: indexNQNGevhHl5EOSCSbNXLSk0gMwfcrF86lATpVyqywmOEMeta || {},
    component: () => import("/opt/build/repo/pages/admin/index.vue")
  }
]
  },
  {
    name: "boms",
    path: "/boms",
    meta: indexb71or2Kox6hT_LXAETSlwMcpKrjuc4_WDO0Syov3Uy8Meta || {},
    component: () => import("/opt/build/repo/pages/boms/index.vue")
  },
  {
    name: "components",
    path: "/components",
    meta: { ...(components6c5rAQkgP5bw5KX3F63hRz5cCgnkn9eLth6H72GskxAMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/components.vue")
  },
  {
    name: dashboardXZDZjzi_tqfZzr_Zbs4x0NDqXk_KqTTs80Jgwyh2z00Meta?.name,
    path: "/dashboard",
    meta: dashboardXZDZjzi_tqfZzr_Zbs4x0NDqXk_KqTTs80Jgwyh2z00Meta || {},
    component: () => import("/opt/build/repo/pages/dashboard.vue"),
    children: [
  {
    name: "dashboard-all",
    path: "all",
    component: () => import("/opt/build/repo/pages/dashboard/all.vue")
  },
  {
    name: "dashboard-my-orders",
    path: "my-orders",
    component: () => import("/opt/build/repo/pages/dashboard/my-orders.vue")
  },
  {
    name: "dashboard",
    path: "",
    component: () => import("/opt/build/repo/pages/dashboard/index.vue")
  }
]
  },
  {
    name: "error-test",
    path: "/error-test",
    meta: indexk1asxzRLb8lag7WgpmUhr5TGCNjImeHvLaP7BVrqIREMeta || {},
    component: () => import("/opt/build/repo/pages/error-test/index.vue")
  },
  {
    name: expensesaxgS2mz5uE4xk2_mhGI2rfDmGL0rIwaCyF4a71bndoAMeta?.name,
    path: "/expenses",
    meta: expensesaxgS2mz5uE4xk2_mhGI2rfDmGL0rIwaCyF4a71bndoAMeta || {},
    component: () => import("/opt/build/repo/pages/expenses.vue"),
    children: [
  {
    name: "expenses-export",
    path: "export",
    component: () => import("/opt/build/repo/pages/expenses/export.vue")
  },
  {
    name: "expenses-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/expenses/new.vue")
  },
  {
    name: _91id_93t6HKUPZXO5PvYcaI5s5IzhWSjcONiGJeF1f3Hm2dFFQMeta?.name,
    path: ":id()",
    meta: _91id_93t6HKUPZXO5PvYcaI5s5IzhWSjcONiGJeF1f3Hm2dFFQMeta || {},
    component: () => import("/opt/build/repo/pages/expenses/[id].vue"),
    children: [
  {
    name: "expenses-id-edit",
    path: "edit",
    meta: editMlBsyNRb82blHwj00_7MvbDykQH1htvomFOoMbb693QMeta || {},
    component: () => import("/opt/build/repo/pages/expenses/[id]/edit.vue")
  },
  {
    name: "expenses-id",
    path: "",
    component: () => import("/opt/build/repo/pages/expenses/[id]/index.vue")
  }
]
  },
  {
    name: "expenses",
    path: "",
    component: () => import("/opt/build/repo/pages/expenses/index.vue")
  }
]
  },
  {
    name: forgot_45passwordVnp08g8UP5IibR6KIZMlsnAFBHWyQodiyjtdQRScWBIMeta?.name,
    path: "/forgot-password",
    meta: { ...(forgot_45passwordVnp08g8UP5IibR6KIZMlsnAFBHWyQodiyjtdQRScWBIMeta || {}), ...{"middleware":"clear-auth-token"} },
    component: () => import("/opt/build/repo/pages/forgot-password.vue"),
    children: [
  {
    name: "forgot-password-check-email",
    path: "check-email",
    component: () => import("/opt/build/repo/pages/forgot-password/check-email.vue")
  },
  {
    name: "forgot-password-uuid-reset",
    path: ":uuid()/reset",
    component: () => import("/opt/build/repo/pages/forgot-password/[uuid]/reset.vue")
  },
  {
    name: "forgot-password",
    path: "",
    component: () => import("/opt/build/repo/pages/forgot-password/index.vue")
  }
]
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: indexW6WZCIAz_phem_WCVaxz_3diYEk1wjnRMy5GyS6lwUgMeta || {},
    component: () => import("/opt/build/repo/pages/inventory/index.vue"),
    children: [
  {
    name: "inventory-index-id-transactions",
    path: ":id()/transactions",
    component: () => import("/opt/build/repo/pages/inventory/index/[id]/transactions.vue")
  }
]
  },
  {
    name: invoicesDOZZG5N4QFrQYQWAi3snrXiIPBRSCOIF_suIwopVh2EMeta?.name,
    path: "/invoices",
    meta: invoicesDOZZG5N4QFrQYQWAi3snrXiIPBRSCOIF_suIwopVh2EMeta || {},
    component: () => import("/opt/build/repo/pages/invoices.vue"),
    children: [
  {
    name: "invoices-exports",
    path: "exports",
    component: () => import("/opt/build/repo/pages/invoices/exports.vue")
  },
  {
    name: "invoices-inbox",
    path: "inbox",
    component: () => import("/opt/build/repo/pages/invoices/inbox.vue")
  },
  {
    name: "invoices",
    path: "",
    meta: indexnf6UKP8TY2PP2HIr60mkm5ibNeIK_6bSwNIg6mgcq0AMeta || {},
    component: () => import("/opt/build/repo/pages/invoices/index.vue"),
    children: [
  {
    name: "invoices-index-export",
    path: "export",
    component: () => import("/opt/build/repo/pages/invoices/index/export.vue")
  }
]
  }
]
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(logingUcKU0V7fZP3Ss3UByM2PjTTHYd1pgiwb9kFWthzQbUMeta || {}), ...{"middleware":"clear-auth-token"} },
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexqjdthQPIBM9IhD2VRI0aXKEOJddcv72aAbUDCMXk7qUMeta || {},
    component: () => import("/opt/build/repo/pages/orders/index.vue")
  },
  {
    name: profileMef4H_TYc_66_EJ0KHQA0H9_ahI_1_KuhHgYlomIVdYMeta?.name,
    path: "/profile",
    meta: profileMef4H_TYc_66_EJ0KHQA0H9_ahI_1_KuhHgYlomIVdYMeta || {},
    component: () => import("/opt/build/repo/pages/profile.vue"),
    children: [
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/opt/build/repo/pages/profile/notifications.vue")
  },
  {
    name: "profile-password",
    path: "password",
    component: () => import("/opt/build/repo/pages/profile/password.vue")
  },
  {
    name: "profile",
    path: "",
    component: () => import("/opt/build/repo/pages/profile/index.vue")
  }
]
  },
  {
    name: "projects",
    path: "/projects",
    meta: indexgc71qn6UgAQ5o_7jsauI59C7PZZaVPgfD5q0UNTMtYYMeta || {},
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "quickbooks-disconnect",
    path: "/quickbooks-disconnect",
    meta: quickbooks_45disconnectuVWpUOT7fldfVIv8_8Y3W1fcvi_Zrj_rK1uYs5XNoYEMeta || {},
    component: () => import("/opt/build/repo/pages/quickbooks-disconnect.vue")
  },
  {
    name: requisitions8Sz_nrXxm2Tg5Oo9SD_tct6PYrXu8BchN9hIZvkzz5oMeta?.name,
    path: "/requisitions",
    meta: requisitions8Sz_nrXxm2Tg5Oo9SD_tct6PYrXu8BchN9hIZvkzz5oMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions.vue"),
    children: [
  {
    name: "requisitions-id",
    path: ":id()",
    meta: index_Dscy93lXj6vUUjoatFJmc5AeVJyM77QFoHw2PTnY4QMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions/[id]/index.vue")
  },
  {
    name: "requisitions",
    path: "",
    component: () => import("/opt/build/repo/pages/requisitions/index.vue")
  }
]
  },
  {
    name: "setup-mode",
    path: "/setup-mode",
    component: () => import("/opt/build/repo/pages/setup-mode.vue")
  },
  {
    name: sign_45up8yzWxtkMj99FD6mwxWcUj_iXyg5WAvGnnnnYEnqRlRMMeta?.name,
    path: "/sign-up",
    meta: { ...(sign_45up8yzWxtkMj99FD6mwxWcUj_iXyg5WAvGnnnnYEnqRlRMMeta || {}), ...{"middleware":["signup-enabled","clear-auth-token"]} },
    component: () => import("/opt/build/repo/pages/sign-up.vue"),
    children: [
  {
    name: "sign-up-profile",
    path: "profile",
    component: () => import("/opt/build/repo/pages/sign-up/profile.vue")
  },
  {
    name: "sign-up",
    path: "",
    component: () => import("/opt/build/repo/pages/sign-up/index.vue")
  }
]
  },
  {
    name: "sign-up-mobile",
    path: "/sign-up-mobile",
    meta: { ...(sign_45up_45mobileOw95MmiD9hJdPAqaafAD6MFXHD7zaGwQm3PjhSSvMIAMeta || {}), ...{"middleware":"signup-enabled"} },
    component: () => import("/opt/build/repo/pages/sign-up-mobile.vue")
  },
  {
    name: "signing",
    path: "/signing",
    meta: signingcz51Se5zPLdV0sv3iPkR9ycPuliB7BZW_hk5njJyrVEMeta || {},
    component: () => import("/opt/build/repo/pages/signing.vue")
  },
  {
    name: suppliersORjQ_GFEA_xLASvPA8clslMAM5Z9Hp9M0Ab5yA_Kk4AMeta?.name,
    path: "/suppliers",
    meta: { ...(suppliersORjQ_GFEA_xLASvPA8clslMAM5Z9Hp9M0Ab5yA_Kk4AMeta || {}), ...{"middleware":"staff"} },
    component: () => import("/opt/build/repo/pages/suppliers.vue"),
    children: [
  {
    name: newekVGmRxWzRZSDWRbIfpHr16T8hyP0MDTHNRdQE4YPQIMeta?.name,
    path: "new",
    component: () => import("/opt/build/repo/pages/suppliers/new.vue"),
    children: [
  {
    name: "suppliers-new-contacts-new",
    path: "contacts/new",
    component: () => import("/opt/build/repo/pages/suppliers/new/contacts/new.vue")
  },
  {
    name: "suppliers-new-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/suppliers/new/categories.vue")
  },
  {
    name: "suppliers-new-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/suppliers/new/contacts/index.vue")
  },
  {
    name: "suppliers-new",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/new/index.vue")
  }
]
  },
  {
    name: "suppliers-id",
    path: ":id()",
    component: () => import("/opt/build/repo/pages/suppliers/[id].vue"),
    children: [
  {
    name: editc57_uvoCEnmtNBW6k1leWbaGGIHTPBBLVbKQPntFqRwMeta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit.vue"),
    children: [
  {
    name: "suppliers-id-edit-contacts-new",
    path: "contacts/new",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/new.vue")
  },
  {
    name: "suppliers-id-edit-contacts-contactId",
    path: "contacts/:contactId()",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/[contactId].vue")
  },
  {
    name: "suppliers-id-edit-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/categories.vue")
  },
  {
    name: "suppliers-id-edit-companies",
    path: "companies",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/companies.vue")
  },
  {
    name: "suppliers-id-edit-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/contacts/index.vue")
  },
  {
    name: "suppliers-id-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/edit/index.vue")
  }
]
  },
  {
    name: "suppliers-id-merge",
    path: "merge",
    component: () => import("/opt/build/repo/pages/suppliers/[id]/merge.vue")
  }
]
  },
  {
    name: "suppliers",
    path: "",
    component: () => import("/opt/build/repo/pages/suppliers/index.vue")
  }
]
  },
  {
    name: "users",
    path: "/users",
    meta: { ...(indexZeHzX2B12kodz3iEviVHBV4jjUVq0oWqo_g5ttjaVzUMeta || {}), ...{"middleware":"can-manage-users"} },
    component: () => import("/opt/build/repo/pages/users/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexAFyRF2Bn_1ZTsou4nMHZtf7Tr5u4fbbDR_Vv2gtSIp4Meta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: suppliersaM_uZuX1Ih6GBr2vmbsl_v8QrroFVj7_Z6rFuqzrAfQMeta?.name,
    path: "/companies/:id()/suppliers",
    meta: suppliersaM_uZuX1Ih6GBr2vmbsl_v8QrroFVj7_Z6rFuqzrAfQMeta || {},
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers.vue"),
    children: [
  {
    name: import_JbSqzSS_kmtosqvsJ4KkFPiejyC1kGj304JoM08MJoMeta?.name,
    path: "import",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import.vue"),
    children: [
  {
    name: "companies-id-suppliers-import-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import/review.vue")
  },
  {
    name: "companies-id-suppliers-import",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/import/index.vue")
  }
]
  },
  {
    name: "companies-id-suppliers",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index.vue"),
    children: [
  {
    name: adddGoa_TcjXjf7LOyMrKux03k189NfAe3cxjEIwxqrLOYMeta?.name,
    path: "add",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add.vue"),
    children: [
  {
    name: "companies-id-suppliers-index-add-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/categories.vue")
  },
  {
    name: "companies-id-suppliers-index-add-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/contacts.vue")
  },
  {
    name: "companies-id-suppliers-index-add-in-store",
    path: "in-store",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/in-store.vue")
  },
  {
    name: "companies-id-suppliers-index-add-new",
    path: "new",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/new.vue")
  },
  {
    name: "companies-id-suppliers-index-add",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/add/index.vue")
  }
]
  },
  {
    name: _91companyVendorId_93L56KD4yLe4xRoSMkhWRyORLmtMJ9TLGk7NR_7IqH6EoMeta?.name,
    path: ":companyVendorId()",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId].vue"),
    children: [
  {
    name: "companies-id-suppliers-index-companyVendorId-contacts-contact",
    path: "contacts/:contact()",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/contacts/[contact].vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-accounting",
    path: "accounting",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/accounting.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-contacts",
    path: "contacts",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/contacts/index.vue")
  },
  {
    name: editlplrrgAJfjuGT7m20O5Vg1NBiG9hLKXuTF2hhDsHFC4Meta?.name,
    path: "edit",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit.vue"),
    children: [
  {
    name: "companies-id-suppliers-index-companyVendorId-edit-categories",
    path: "categories",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit/categories.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-edit",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/edit/index.vue")
  }
]
  },
  {
    name: "companies-id-suppliers-index-companyVendorId-map",
    path: "map",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/map.vue")
  },
  {
    name: "companies-id-suppliers-index-companyVendorId",
    path: "",
    component: () => import("/opt/build/repo/pages/companies/[id]/suppliers/index/[companyVendorId]/index.vue")
  }
]
  }
]
  }
]
  },
  {
    name: newNTTcQDB_rDrDnG56lE8RA0FNC8e6veZjY4wHVANRFmcMeta?.name,
    path: "/invoices/new",
    meta: newNTTcQDB_rDrDnG56lE8RA0FNC8e6veZjY4wHVANRFmcMeta || {},
    component: () => import("/opt/build/repo/pages/invoices/new.vue"),
    children: [
  {
    name: "invoices-new",
    path: "",
    component: () => import("/opt/build/repo/pages/invoices/new/index.vue")
  }
]
  },
  {
    name: new_sypVvLZdQyc1WMLWPlf6IxERR_Blc0_wNAEDt5t4ZcMeta?.name,
    path: "/requisitions/new",
    meta: new_sypVvLZdQyc1WMLWPlf6IxERR_Blc0_wNAEDt5t4ZcMeta || {},
    component: () => import("/opt/build/repo/pages/requisitions/new.vue"),
    children: [
  {
    name: "requisitions-new-approval",
    path: "approval",
    component: () => import("/opt/build/repo/pages/requisitions/new/approval.vue")
  },
  {
    name: "requisitions-new-delivery",
    path: "delivery",
    component: () => import("/opt/build/repo/pages/requisitions/new/delivery.vue")
  },
  {
    name: "requisitions-new-review",
    path: "review",
    component: () => import("/opt/build/repo/pages/requisitions/new/review.vue")
  },
  {
    name: "requisitions-new",
    path: "",
    component: () => import("/opt/build/repo/pages/requisitions/new/index.vue")
  }
]
  },
  {
    name: "requisitions-id-edit",
    path: "/requisitions/:id()/edit",
    meta: editYdJdxHayb0MvPeg6P01iiPoTOfFAnTHLU8jKnpwxmL0Meta || {},
    component: () => import("/opt/build/repo/pages/requisitions/[id]/edit.vue")
  }
]